import axiosInstance from "@helper/interceptor";

export const getEsgResourceEfficiency = async ({ year, project_id, area_id }) => {
  const params = new URLSearchParams();
  if (year) params.append("year", year);
  if (project_id) params.append("project_id", project_id);
  if (area_id) params.append("area_id", area_id);
  const response = await axiosInstance.get(`/dashboard/esg/resource-efficiency?${params}`);
  return response?.data ?? response;
};
